import { createFileRoute } from '@tanstack/react-router'
import { MailLinkFallback } from './-components/mail-link-fallback'
import {
	buildMailLinkSeo,
	mailLinkSearchSchema
} from './-lib/mail-link-fallback'

export const Route = createFileRoute('/(public)/reset-password')({
	ssr: true,
	validateSearch: mailLinkSearchSchema,
	head: ({ match }) =>
		buildMailLinkSeo({
			appLanguage: match.context.appLanguage,
			flow: 'reset_password',
			path: '/reset-password'
		}),
	component: ResetPasswordFallback
})

function ResetPasswordFallback() {
	const { appLanguage } = Route.useRouteContext()
	const { token } = Route.useSearch()
	return (
		<MailLinkFallback
			appLanguage={appLanguage}
			flow='reset_password'
			proof={token}
		/>
	)
}
